import { useTranslate } from '@refinedev/core';
import { Card, Descriptions, Typography } from 'antd';
import type { DescriptionsProps } from 'antd';
import type { TagDetailOut } from '@/api/generated/schemas';
import { LabelsTags } from '@/components/common/LabelsField';
import { orDash, useVerticalDescProps } from '@/components/common/show/shared';
import { formatDateTime } from '@/utils/format';

const { Text } = Typography;

interface TagGeneralTabProps {
  record: TagDetailOut;
}

export const TagGeneralTab = ({ record }: TagGeneralTabProps) => {
  const t = useTranslate();
  const verticalDescProps = useVerticalDescProps();

  const items: DescriptionsProps['items'] = [
    {
      key: 'id',
      label: t('base.fields.id'),
      children: orDash(record.id),
    },
    {
      key: 'name',
      label: t('user_catalog.tags.fields.name'),
      children: orDash(record.name),
    },
    {
      key: 'slug',
      label: t('user_catalog.tags.fields.slug'),
      children: orDash(record.slug && <Text code>{record.slug}</Text>),
    },
    {
      key: 'labels',
      label: t('base.labels._field'),
      children: <LabelsTags labels={record.labels} />,
    },
    {
      key: 'created_at',
      label: t('base.fields.created_at'),
      children: orDash(formatDateTime(record.created_at)),
    },
    {
      key: 'updated_at',
      label: t('base.fields.updated_at'),
      children: orDash(formatDateTime(record.updated_at)),
    },
  ];

  return (
    <Card title={t('base.sections.basic_info')}>
      <Descriptions
        {...verticalDescProps}
        column={{ xs: 1, sm: 2, md: 3 }}
        items={items}
      />
    </Card>
  );
};
